import React from 'react'
import Field, { type IFieldProps } from './Field'
import { type Control, Controller, type RegisterOptions } from 'react-hook-form'
import CheckboxControl from './CheckboxControl'

interface IProps extends IFieldProps {
  name: string
  control: Control<any>
  rules?: RegisterOptions
  children?: React.ReactElement | string
}

const CheckboxSingle: React.FC<IProps> = (props) => {
  return (
    <Field
      {...{
        ...props,
        className: `checkbox-single ${props.className ?? ''}`.trim(),
      }}
      render={() => (
        <Controller
          control={props.control}
          name={props.name}
          rules={props.rules}
          render={({ field }) => (
            <CheckboxControl
              hasError={props.hasError}
              disabled={props.disabled}
              onChange={field.onChange}
              value={field.value ?? false}
              name={field.name}
            >
              {props.children}
            </CheckboxControl>
          )}
        ></Controller>
      )}
    ></Field>
  )
}

export default CheckboxSingle
